module.exports = __webpack_public_path__ + "img/ic_12_arrow_down_white.56adbc17.svg";